import { AVR_ENABLE_GTM, GTM_BASE_URL } from "../config/env";

let isGTMLoaded = false;

export const loadGTM = (gtmId: string) => {
  const isEnabled =  AVR_ENABLE_GTM === "true" || AVR_ENABLE_GTM === true;
  if(!isEnabled) {
    console.log("GTM is disabled");
  }
  
  if (!gtmId || isGTMLoaded) return;
  isGTMLoaded = true;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `${GTM_BASE_URL}/gtm.js?id=${gtmId}`;

  script.onload = () => {
  };

  document.head.appendChild(script);
};